export const AUTO_LOGIN_TOOLTIP_DISMISSED_COOKIE_KEY = 'zl_auto_login_tooltip_dismissed';
//# sourceMappingURL=constants.js.map